import request from '#/utils/request';
import { keysToSnake } from '#/api/adapters/wireCase';
import { parseVer4DetailResponse } from '#/api/adapters/envelope';

/**
 * GET /mom/work-order/draft-plan
 * @param {{ customerOrderId: string, productId?: string|null }} params
 * @see docs/API_MOMMGMT_WORK_ORDER.md
 */
export async function fetchWorkOrderDraftPlan({ customerOrderId, productId } = {}) {
  const query = { customerOrderId };
  if (productId) {
    query.productId = productId;
  }
  const { data: raw } = await request.get('/mom/work-order/draft-plan', {
    params: keysToSnake(query),
  });
  return parseVer4DetailResponse(raw);
}
